import { datadogRum } from "@datadog/browser-rum";

export const logExperimentGroup = (isExperimentGroup: boolean) => {
  datadogRum.addAction("Experiment Group Set", {
    experimentGroup: isExperimentGroup ? "Experiment" : "Control",
  });
};
